import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { Landing } from "./player/Landing";
import { Join } from "./player/Join";
import { Play } from "./player/Play";
import { Login } from "./host/Login";
import { Register } from "./host/Register";
import { MagicConsume } from "./host/MagicConsume";
import { ResetPassword } from "./host/ResetPassword";

// Superfícies de anfitrião e palco em chunks separados: o jogador (alvo do
// Lighthouse ≥90) não baixa editor/radix/motion/confetti (docs/06 M5).
const HostHome = lazy(() => import("./host/HostHome").then((m) => ({ default: m.HostHome })));
const QuizEditor = lazy(() => import("./host/QuizEditor").then((m) => ({ default: m.QuizEditor })));
const StartSession = lazy(() =>
  import("./host/StartSession").then((m) => ({ default: m.StartSession })),
);
const Console = lazy(() => import("./host/Console").then((m) => ({ default: m.Console })));
const HostSessions = lazy(() =>
  import("./host/HostSessions").then((m) => ({ default: m.HostSessions })),
);
const SessionReport = lazy(() =>
  import("./host/SessionReport").then((m) => ({ default: m.SessionReport })),
);
const Stage = lazy(() => import("./stage/Stage").then((m) => ({ default: m.Stage })));
const Admin = lazy(() => import("./admin/Admin").then((m) => ({ default: m.Admin })));
const DevUI = import.meta.env.DEV
  ? lazy(() => import("./devui/DevUI").then((m) => ({ default: m.DevUI })))
  : () => null;

export function App() {
  return (
    <Suspense fallback={<div className="bg-bg min-h-dvh" />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/j/:code" element={<Join />} />
        <Route path="/play/:code" element={<Play />} />
        <Route path="/entrar" element={<Login />} />
        <Route path="/criar-conta" element={<Register />} />
        <Route path="/auth/magic" element={<MagicConsume />} />
        <Route path="/redefinir-senha" element={<ResetPassword />} />
        <Route path="/host" element={<HostHome />} />
        <Route path="/host/quiz/:id" element={<QuizEditor />} />
        <Route path="/host/quiz/:id/iniciar" element={<StartSession />} />
        <Route path="/host/sala/:code" element={<Console />} />
        <Route path="/host/sessoes" element={<HostSessions />} />
        <Route path="/host/sessoes/:code" element={<SessionReport />} />
        <Route path="/palco/:code" element={<Stage />} />
        <Route path="/admin" element={<Admin />} />
        {import.meta.env.DEV && <Route path="/dev/ui" element={<DevUI />} />}
        <Route path="*" element={<Landing />} />
      </Routes>
    </Suspense>
  );
}
